<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Customers from "@/services/Customers";
import modalEditUser from "@/components/modals/customers/modalEditUser";
import modalEditPhone from "@/components/modals/customers/modalEditPhone";
import modalEditAddress from "@/components/modals/customers/modalEditAddress";
import modalEditEmail from "@/components/modals/customers/modalEditEmail";
import modalEditAttributes from "@/components/modals/customers/modalEditAttributes";
import modalAddAddress from "@/components/modals/customers/modalAddAddress";
import modalAddPhone from "@/components/modals/customers/modalAddPhone";
import modalSendPushNotification from "@/components/modals/customers/modalSendPushNotification";
import modalCreateCustomerFromPotential from "@/components/modals/customers/modalCreateCustomerFromPotential";
import modalChangePassword from "@/components/modals/customers/modalChangePassword";
import modalChangeUserPicture from "@/components/modals/customers/modalChangeUserPicture";
import TabCustomerDevices from "@/components/tabs/tabCustomerDevices";
import TabCustomerOrders from "@/components/tabs/tabCustomerOrders";
import TabCustomerTicketing from "@/components/tabs/tabCustomerTicketing";
import TabCustomerSocial from "@/components/tabs/tabCustomerSocial";
import TabCustomerCashless from "@/components/tabs/tabCustomerCashless";
import TabFanExperience from "@/components/tabs/tabFanExperience";
import TabCustomerCollectibles from "@/components/tabs/tabCustomerCollectibles";
import TabCustomerCloudSave from "@/components/tabs/TabCustomerCloudSave";
import TabCustomerEmails from "@/components/tabs/TabCustomerEmails";
import Devices from '@/services/Devices';
import Notification from '@/services/Notification';


import Swal from "sweetalert2";

/**
 * Profile component
 */
export default {
  components: {
    Layout,
    PageHeader,
    modalEditPhone,
    modalEditAddress,
    modalEditEmail,
    modalEditAttributes,
    modalAddAddress,
    modalAddPhone,
    TabCustomerDevices,
    TabCustomerOrders,
    modalEditUser,
    modalSendPushNotification,
    modalChangePassword,
    modalCreateCustomerFromPotential,
    modalChangeUserPicture,
    TabCustomerTicketing,
    TabCustomerSocial,
    TabCustomerCashless,
    TabFanExperience,
    TabCustomerCollectibles,
    TabCustomerCloudSave,
    TabCustomerEmails
  },
  page: {
    title: "Profile",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      blurConfig: {
        isBlurred: false, // activate and deactivate based on a boolean value and also provide a config
        opacity: 0.1,
        filter: "blur(1.5px)",
        transition: "all .3s linear",
      },
      title: "Profile",
      items: [
        {
          text: "Users",
        },
        {
          text: "Users",
          active: true,
        },
      ],
      customerInfo: {
        id: "",
        email: "",
        first_name: "",
        last_name: "",
        middle_name: "",
        initials: "",
        date_of_birth: "",
        gender: "",
        created_on: "",
        last_successful_login: "",
        nickname: "",
        salutation: "",
        status: "",
      },
      customerDevices:[],
      activeTab: 0,
      preferences:[],
      preferencesTypes: [],
      deviceId:null,
      notifTypes: [],
      customerEmails: {},
      customerAddresses: {},
      customerPhones: {},
      customerAttributes: {},
      customerAttributesOptIn: {},
      customerTicketingValidatedUser: {},
      lastLoginAttempts: {},
      error: null,
      errorPreferences: null,
      noPushTokenErr:null,
      modalData: {},
      customer_id: "",
      toggleProfile: false,
      showLoader: false,
      showPreferencesLoader:false,
      customerTicketingProvider: "",
      customerProviderData: [],
      side_menu_list: localStorage.getItem("access_objects"),
      customerAlert: false,
      potentialUser: false,
      primaryEmail: '',
      ssoId: ''
    };
  },
  async mounted() {

    try {
      await this.getCustomer();
    } catch (e) {
      console.warn('getCustomer() failed. Trying getPotentialUser()...');

      try {
        await this.getPotentialUser();
      } catch (innerErr) {
        console.error('getPotentialUser() also failed. Stopping...');
        return;
      }

      return;
    }

    this.getLoginAttempts(this.$route.params.id);
    this.getOptIns();
    await this.getUserDevices();
    await this.getNotificationTypes();
    await this.getNotificationPreferences();
  },
  methods: {


    async getUserDevices() {
      this.toggleBusy()
      try {
        const { data } = await Devices.getUserDevices(this.$route.params.id)
        this.customerDevices = data.data
        this.deviceId = data.data[0].device_id
      } catch (err) {
        this.error = err.response?.data?.error || err.message
      } finally {
        this.toggleBusy()
      }
    },
    async getNotificationPreferences() {
      this.showPreferencesLoader = true
      if (this.customerDevices.length > 1){
        this.showPreferencesLoader = false
        return
      }

      try {
        if(this.customerDevices[0].pushtoken) {
          const filter = `device_id=${this.deviceId}&customer_id=${this.$route.params.id}`
          const { data } = await Devices.getNotificationPreferences(filter)
          this.preferences = data.types || []
          // console.log(this.preferences,'preferences');
          this.errorPreferences = data.error || null
          if(this.errorPreferences == 'No preferences for this device'){
          await this.setAllNotificationPreferencesOn();
          }
        }else{
          this.noPushTokenErr = 'No push token!';
          console.error('No push token!')
        }

      } catch (err) {
        this.error = err.response?.data?.error || err.message
      }finally {
        this.showPreferencesLoader = false;
      }
    },
    async getNotificationTypes() {
      this.notifTypes = [];
      await Notification.getNotificationTypes()
              .then((response) => {
                // console.log(response,'types')
                response.data.data.forEach((value) => {
                  this.preferencesTypes.push({type: value.type_code, status: false, 'type_name' : value.type_name})
                });
                this.notifTypes = response.data.data
                // this.getNotificationPreferences();
              })
    },
    async setAllNotificationPreferencesOn() {
      try {
        // Build a payload where every preference is 'Y'
        const types = this.preferencesTypes.map(pt => ({
          type:   pt.type,
          status: 'Y'
        }))
          // console.log(types);
        // Send it to the backend
        await Devices.updatePreferences({
          device_id:   this.customerDevices[0].device_id,
          customer_id: this.$route.params.id,
          types:types,
          csrf_token:  this.csrf_token
        })


        await this.getNotificationPreferences()

      } catch (err) {
        this.error = err.response?.data?.error || err.message
        console.error("Failed to set all preferences on:", this.error)
      }
    },
    async getCustomer() {
      this.showLoader = true;
      const filter = 'include_user_picture=true'
      await Customers.getCustomer(this.$route.params.id,filter)
        .then((response) => {
          // console.log(response,'res');
          this.getUserDevices()
          this.getNotificationPreferences()
          this.customerInfo = response.data.customer.info;
          this.customerEmails = response.data.customer.emails
            ? response.data.customer.emails
            : [];
          this.customerAddresses = response.data.customer.address
            ? response.data.customer.address
            : [];
          this.customerPhones = response.data.customer.phones
            ? response.data.customer.phones
            : [];
          this.customerAttributes = response.data.customer.attributes
            ? response.data.customer.attributes
            : [];
          this.customerTicketingValidatedUser = response.data.customer.ticketing_validated_user !== undefined
                  ? response.data.customer.ticketing_validated_user
                  : [];

          this.ssoId = response.data.customer.sso_id || '';

          const primary = this.customerEmails.find(e => e.primary === 'Y');
          this.primaryEmail = primary && primary.email ? primary.email : '';
        })
        .catch((error) => {
          this.error = error.response.data.error
            ? error.response.data.error
            : "";
          if (this.error) {
            //this.customerAlert = true;
          }
          throw error;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },

    async getPotentialUser(){
      this.showLoader = true;
      await Customers.getPotentialCustomer(this.$route.params.id)
        .then((response) => {
          this.potentialUser = true
          this.customerInfo = response.data.customer.info;
          this.customerInfo.status = 'potential'
          this.customerEmails = response.data.customer.emails
                  ? response.data.customer.emails
                  : [];
          this.customerAddresses = response.data.customer.address
                  ? response.data.customer.address
                  : [];
          this.customerPhones = response.data.customer.phones
                  ? response.data.customer.phones
                  : [];
          this.customerAttributes = response.data.customer.attributes
                  ? response.data.customer.attributes
                  : [];
          this.customerTicketingValidatedUser = response.data.customer.ticketing_validated_user !== undefined
                  ? response.data.customer.ticketing_validated_user
                  : [];
        })
        .catch((error) => {
          this.error = error.response.data.error
                  ? error.response.data.error
                  : "";
          if (this.error) {
            this.customerAlert = true;
          }
          throw error;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },

    async getOptIns() {
      await Customers.getCustomerOptIns(this.$route.params.id)
        .then((response) => {
          this.customerAttributesOptIn = response.data.data;
          // console.log(this.customerAttributesOptIn,'optins')
        })
        .catch((error) => {
          this.error = error.response.data.error
            ? error.response.data.error
            : "";
        });
    },
    async getLoginAttempts(customer_id) {
      try {
        const response = await Customers.getLoginAttempts(customer_id);
        this.lastLoginAttempts = response.data.last_login_attempts.data.last_successful_login;

      } catch (error) {
        this.error = error.response?.data?.error || "An error occurred";
        console.error("Error fetching login attempts:", this.error);
      }
    },
    async validateUser() {
      const isCurrentlyVerified = this.customerTicketingValidatedUser === true;
      const actionText = isCurrentlyVerified ? "Unverify" : "Verify";
      const actionMessage = isCurrentlyVerified
          ? "This user will be unverified!"
          : "This user will be verified!";

      const confirm = await Swal.fire({
        title: `${actionText} Ticket User?`,
        text: actionMessage,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: `${actionText}!`,
      });

      if (!confirm.isConfirmed) return;

      try {
        const dataToUpdate = {
          ticketing_validated_user: isCurrentlyVerified ? 0 : 1,
        };

        const response = await Customers.verifiedUser(dataToUpdate, this.$route.params.id);

        if (!response.data || response.data.error) {
          throw new Error(response.data.error || "Failed to update user status.");
        }

        this.customerTicketingValidatedUser = dataToUpdate.ticketing_validated_user;

        this.$emit("userVerificationUpdated", this.customerTicketingValidatedUser);

        const pastTenseAction = isCurrentlyVerified ? "unverified" : "verified";

        Swal.fire(
                `${pastTenseAction.charAt(0).toUpperCase() + pastTenseAction.slice(1)}!`,
                `User has been successfully ${pastTenseAction}!`,
                "success"
        );
      } catch (error) {
        let errorMessage = "An unexpected error occurred.";

        // Extract detailed error messages
        if (error.response) {
          if (error.response.status === 422) {
            errorMessage = error.response.data.error || "Invalid input data.";
          } else if (error.response.data) {
            errorMessage = error.response.data.error || error.response.data.message || errorMessage;
          }
        } else if (error.message) {
          errorMessage = error.message;
        }

        Swal.fire("Fail!", errorMessage, "warning");
      }finally {
        this.getCustomer();
      }
    },

    formatAttribute(attributeName) {
      attributeName = attributeName.replace(/_/g, " ");
      return attributeName.charAt(0).toUpperCase() + attributeName.slice(1);
    },
    showGender() {
      var genderIcon = "";
      if (this.customerInfo.gender == "M") {
        genderIcon = '<i class="fas fa-mars text-info" title="Male"></i>';
      } else if (this.customerInfo.gender == "F") {
        genderIcon = '<i class="fas fa-venus text-danger" title="Female"></i>';
      } else {
        genderIcon = '<i class="fas fa-genderless" title="No Gender"></i>';
      }

      return genderIcon;
    },

    callModalAddressAdd(customerID) {
      this.$bvModal.show("address_add");
      this.customer_id = customerID;
    },
    callModalAddressEdit(data) {
      this.$bvModal.show("address_edit");
      this.modalData = data;
    },
    callModalPhoneAdd(customerID) {
      this.$bvModal.show("phone_add");
      this.customer_id = customerID;
    },
    callModalPhoneEdit(data) {
      this.$bvModal.show("phone_edit");
      this.modalData = data;
    },
    callModalMailEdit(data) {
      this.$bvModal.show("mail_edit");
      this.modalData = data;
    },
    callModalUserEdit(data) {
      this.$bvModal.show("user_edit");
      this.modalData = data;
    },
    callModalChangeUserPicture(data,user_pic){
      this.$bvModal.show("user_picture");
      this.modalData = data;
      this.modalData.user_picture = user_pic;
    },
    callModalSendPushNotification(data) {
      this.$bvModal.show("send_notification");
      this.modalData = data;
    },
    callModalChangePassword(data) {
      this.$bvModal.show("change_password");
      this.modalData = data;
    },

    addressRemove(id) {
      Swal.fire({
        title: "Remove this user address?",
        text: "This Address will be removed from the user!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Remove!",
      }).then((result) => {
        if (result.value) {
          try {
            Customers.removeAddress(id).then((response) => {
              const res = response.data ? response.data : false;
              const error = response.data.error
                ? response.data.error
                : "Failed";
              if (res) {
                this.getCustomer();
                Swal.fire(
                  "Remove from user address",
                  "Address is successfully removed from the list!",
                  "success"
                );
              } else {
                Swal.fire("Fail!", error, "warning");
              }
            });
          } catch (error) {
            this.error = error.response.data.error
              ? error.response.data.error
              : "";
          }
        }
      });
    },

    phoneRemove(id) {
      Swal.fire({
        title: "Remove this user phone?",
        text: "This phone will be removed from the user!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Remove!",
      }).then((result) => {
        if (result.value) {
          try {
            Customers.removePhone(id).then((response) => {
              const res = response.data ? response.data : false;
              const error = response.data.error
                ? response.data.error
                : "Failed";
              if (res) {
                this.getCustomer();
                Swal.fire(
                  "Remove from user phone",
                  "Phone is successfully removed from the list!",
                  "success"
                );
              } else {
                Swal.fire("Fail!", error, "warning");
              }
            });
          } catch (error) {
            this.error = error.response.data.error
              ? error.response.data.error
              : "";
          }
        }
      });
    },

    deleteCustomer() {
      Swal.fire({
        title: "Action Delete Customer",
        icon: "warning",
        html: `
            <p>Please note that all data related to this customer will be deleted!</p>
            <h5>Are you sure you want to delete this account?</h5>
            <p>Type "delete" to confirm:</p>
            <input type="text" id="deleteConfirmation" class="swal2-input" placeholder="delete">
        `,
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Delete",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          const confirmationText = Swal.getPopup().querySelector(
            "#deleteConfirmation"
          ).value;
          if (confirmationText !== "delete") {
            Swal.showValidationMessage('You must type "delete" to confirm');
            return false;
          }
          return Customers.deleteCustomer(this.$route.params.id)
            .then((response) => {
              return response;
            })
            .catch((error) => {
              this.error = error.response.data.error
                ? error.response.data.error
                : "";
              Swal.fire("Fail!", this.error, "error");
            });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const res = result.value.data ? result.value.data : false;
          const error = result.value.data.error
            ? result.value.data.error
            : "Failed";
          if (res) {
            Swal.fire(
              "Delete Account",
              "Customer is successfully deleted!",
              "success"
            ).then(() => {
              this.$router.push({ name: "customers" });
            });
          } else {
            Swal.fire("Fail!", error, "warning");
          }
        }
      });
    },

    deletePotentialCustomer() {
      Swal.fire({
        title: "Action Delete Potential Customer",
        icon: "warning",
        html: `
            <p>Please note that this potential customer record will be deleted.</p>
            <p>This action will also detach the customer from the ticketing provider.</p>
            <h5>Are you sure you want to proceed?</h5>
            <p>Type "delete" to confirm:</p>
            <input type="text" id="deletePotentialConfirmation" class="swal2-input" placeholder="delete">
        `,
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Delete",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          const confirmationText = Swal.getPopup().querySelector(
            "#deletePotentialConfirmation"
          ).value;
          if (confirmationText !== "delete") {
            Swal.showValidationMessage('You must type "delete" to confirm');
            return false;
          }
          return Customers.deletePotentialCustomer(this.$route.params.id)
            .then((response) => {
              return response;
            })
            .catch((error) => {
              this.error = error.response?.data?.error
                ? error.response.data.error
                : "";
              Swal.fire("Fail!", this.error, "error");
            });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const res = result.value && result.value.data ? result.value.data : false;
          const error =
            result.value && result.value.data && result.value.data.error
              ? result.value.data.error
              : "Failed";
          if (res) {
            Swal.fire(
              "Delete Potential Account",
              "Potential customer is successfully deleted!",
              "success"
            ).then(() => {
              this.$router.push({ name: "customers" });
            });
          } else {
            Swal.fire("Fail!", error, "warning");
          }
        }
      });
    },

    toggle() {
      this.toggleProfile = !this.toggleProfile;
    },

    customerStatus() {
      return this.customerInfo.status;
    },
    customerTicketingValidation() {
      return this.customerTicketingValidatedUser;
    },

    setProviderData(provider, providerData) {
      this.customerTicketingProvider = provider;
      this.customerProviderData = providerData;
    },

    callModalCompanyNameEdit(customerID) {
      this.$bvModal.show("edit_attributes");
      this.customer_id = customerID;
    },

    callModalCreateCustomerFromPotential(){
      this.$bvModal.show("create_from_potential");
    },

    async handleCreatedFromPotential() {
      // After creating a customer from potential, mark as non-potential so all tabs/buttons show
      // Reload customer data
      this.potentialUser = false;
      await this.getCustomer();
    },

    callModalResendVerifyEmail(){

      Swal.fire({
        title: "Resend Verification E-Mail",
        text: "Verification E-mail will be sent to " + this.customerInfo.email,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Send",
      }).then((result) => {
        if (result.value) {
          Customers.resendVerifyEmail({
            email: this.customerInfo.email
          }).then((response) => {
              this.successmsg("Verification email is successfully sent")
          })
          .catch(error => {
              this.failedmsg( error.response.data.error)
          });
        }
      });
    },

  },
  computed: {
    fullName() {
      return [
        this.customerInfo.first_name,
        this.customerInfo.middle_name,
        this.customerInfo.last_name,
      ]
        .filter(Boolean)
        .join(" ");
    },
    user_picture() {
      return this.customerAttributes.user_picture || "";
    },
    favClub(){
       return this.customerAttributes.favClub
          ? this.customerAttributes.favClub
          : "-";
    },
    tenantAVE(){
      return process.env.VUE_APP_TENANT === 'AVE'
    },
    tenantHHC(){
      return process.env.VUE_APP_TENANT === 'HHC'
    },
    menuToArray(){
      return this.side_menu_list ? this.side_menu_list.split(',') : [];
    },
    prettyCloudData(){
      if (this.cloudSaveParsed) {
        try {
          return JSON.stringify(this.cloudSaveParsed, null, 2);
        } catch {
          return String(this.cloudSaveParsed);
        }
      }
      return this.cloudSave?.data || '';
    }
  },
  watch: {
    activeTab(to) {
      if (to === 0) {
        this.getNotificationPreferences()
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row mb-4"  v-if="!customerAlert">
      <div v-if="!toggleProfile" class="col-xl-4">
        <div class="card h-100">
          <div class="card-body" v-if="!showLoader">
            <div class="text-center">
              <b-dropdown
                class="float-end"
                variant="white"
                right
                menu-class="dropdown-menu-end"
                toggle-class="font-size-16 text-body p-0"
                v-if="!potentialUser"
              >
                <template v-slot:button-content>
                  <i class="uil uil-ellipsis-v"></i>
                </template>
                <a
                    class="dropdown-item"
                    :class="{ 'disabled': customerInfo.status === 'deleted' }"
                    href="javascript:void(0);"
                    @click="callModalUserEdit(customerInfo)"
                >Edit</a>
                <a
                    class="dropdown-item"
                    :class="{ 'disabled': customerInfo.status === 'deleted' }"
                    href="javascript:void(0);"
                    @click="callModalChangeUserPicture(customerInfo,user_picture)"
                >Change User Picture</a
                >
                <a
                        v-if="menuToArray.includes('button.customer.profile.sentNotification')"
                        class="dropdown-item"
                        :class="{ 'disabled': customerInfo.status === 'deleted' }"
                        href="javascript:void(0);"
                        @click="callModalSendPushNotification(customerInfo)"
                  >Send Notification</a
                >
                <a
                        v-if="menuToArray.includes('button.customer.profile.changePassword')"
                        class="dropdown-item"
                        :class="{ 'disabled': customerInfo.status === 'deleted' }"
                        href="javascript:void(0);"
                        @click="callModalChangePassword(customerInfo)"
                        >Change Password</a>
                <a
                        class="dropdown-item"
                        :class="{ 'disabled': customerInfo.status === 'deleted' }"
                        href="javascript:void(0);"
                        @click="callModalResendVerifyEmail()"
                >Resend Verification Email</a
                >
                <a class="dropdown-item d-none" href="#">Remove</a>
              </b-dropdown>
              <i
                class="uil uil-angle-left float-start font-size-20 text-body btn p-0"
                @click="toggle"
              ></i>
              <div class="clearfix"></div>
              <div>
                <img
                    v-if="user_picture"
                    :src="user_picture"
                    alt=""
                    class="avatar-lg rounded-circle img-thumbnail"
                    style="object-fit: cover;"
                />
                <img
                  v-else
                  src="@/assets/images/users/avatar-generic.png"
                  alt
                  class="avatar-lg rounded-circle img-thumbnail"
                />
              </div>
              <h3 class="mt-3 mb-1">
                {{ fullName }} <span v-html="showGender()"></span>
              </h3>
              <small class="mt-3 mb-1">{{
                customerInfo.hasOwnProperty("id") ? customerInfo.id : null
              }}</small>
              <small class="d-block mt-3 mb-1" v-if="ssoId && ssoId !== customerInfo.id">
                sso_id:{{ ssoId }}
              </small>
              <p class="mt-2 mb-1">{{ customerInfo.nickname }}</p>
              <div class="mt-2 d-flex justify-content-center">
                <div class="font-size-18" v-html="format_status(customerStatus())"></div>
                <div class=" mt-1 ms-2" v-if="customerTicketingValidation() === true">
                  <span class="text-primary font-size-12">verified</span>
                  <i class="mdi mdi-check-decagram text-success me-2 font-size-12"></i>
                </div>
              </div>
            </div>

            <hr class="my-2" />

            <div class="table-responsive mt-4 mb-0">
              <h5>Contact Information</h5>
              <div class="mt-3">
                <p class="mb-2 text-strong">Emails :</p>
                <p
                  v-for="cusEmail in customerEmails"
                  :key="cusEmail.email_id"
                  class="font-size-16 mb-2  justify-content-between"
                >
                  <span class="mw-80"
                    >{{ cusEmail.email }}
                    <i
                      v-if="cusEmail.primary == 'Y'"
                      class="fas fa-circle text-success font-size-14 d-none"
                      title="Primary email"
                    ></i>
                  </span>

                  <a
                    href="javascript:void(0);"
                    title="Edit email"
                    class="px-2 text-primary float-end"
                    @click="customerInfo.status !== 'deleted' ? callModalMailEdit(cusEmail): null"
                  >
                    <i
                        class="uil uil-pen font-size-18"
                        :class="{ 'disabled': customerInfo.status === 'deleted' }"
                    ></i>

                  </a>
                </p>
              </div>

              <div class="mt-3">
                <p class="mb-2 text-strong">
                  Addresses :
                  <a
                    href="javascript:void(0);"
                    title="Add address"
                    class="px-2 text-primary float-end"
                    @click="customerInfo.status !== 'deleted' ? callModalAddressAdd(customerInfo.id) : null"
                    v-if="!potentialUser"
                  >
                    <i class="uil uil-plus font-size-18"
                       :class="{ 'disabled': customerInfo.status === 'deleted' }">
                    </i>
                  </a>
                </p>

                <p
                  v-for="cusAddress in customerAddresses"
                  :key="cusAddress.address_id"
                  class="font-size-16 mb-2  d-flex justify-content-between"
                >
                  <span class="mw-80">
                    <i
                      v-if="cusAddress.address_type == 'business'"
                      class="mdi mdi-office-building-outline me-2 d-none"
                      title="Work address"
                    ></i>
                    <i
                      v-if="cusAddress.address_type == 'home'"
                      class="mdi mdi-home-variant-outline me-2 d-none"
                      title="Home address"
                    ></i>
                    {{
                      cusAddress.line1 +
                        " " +
                        cusAddress.line2 +
                        (cusAddress.line3 ? " " + cusAddress.line3 : "") +
                        ", " +
                        cusAddress.zip +
                        " " +
                        cusAddress.city +
                        ", " +
                        cusAddress.country
                    }}
                    <i
                      v-if="cusAddress.primary == 'Y'"
                      class="fas fa-circle text-success font-size-14 me-2 d-none"
                      title="Primary address"
                    ></i>
                    <i
                      v-if="cusAddress.verified == 'Y'"
                      class="fas fa-check text-success font-size-14 me-2 d-none"
                      title="Verified address"
                    ></i>
                    <i
                      v-if="cusAddress.mailing == 'Y'"
                      class="fas fa-envelope text-success font-size-14 me-2 d-none"
                      title="Mailing address"
                    ></i>
                  </span>
                  <span>
                    <a
                      href="javascript:void(0);"
                      title="Edit address"
                      class="px-2 text-primary float-end"
                      @click="customerInfo.status !== 'deleted' ? callModalAddressEdit(cusAddress) : null"

                    >
                      <i class="uil uil-pen font-size-18"
                         :class="{ 'disabled': customerInfo.status === 'deleted' }"
                      ></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      title="Remove address"
                      class="float-end text-danger"
                      @click="customerInfo.status !== 'deleted' ? addressRemove(cusAddress.address_id) : null"
                    >
                      <i class="uil uil-trash-alt font-size-18"
                         :class="{ 'disabled': customerInfo.status === 'deleted' }"
                      ></i>
                    </a>
                  </span>
                </p>
              </div>

              <div class="mt-3">
                <p class="mb-2 text-strong">
                  Phones :
                  <a
                    href="javascript:void(0);"
                    title="Add phone"
                    class="px-2 text-primary float-end"
                    @click="customerInfo.status !== 'deleted' ? callModalPhoneAdd(customerInfo.id) : null"
                    v-if="!potentialUser"
                  >
                    <i class="uil uil-plus font-size-18"
                       :class="{ 'disabled': customerInfo.status === 'deleted' }"
                    ></i>
                  </a>
                </p>
                <p
                  v-for="cusPhone in customerPhones"
                  :key="cusPhone.phone_id"
                  class="font-size-16 mb-2  d-flex justify-content-between"
                >
                  <span class="mw-80">
                    <i
                      v-if="cusPhone.phone_type == 'mobile'"
                      class="mdi mdi-cellphone me-2"
                      title="Mobile"
                    ></i>
                    <i
                      v-if="cusPhone.phone_type == 'fixed'"
                      class="mdi mdi-deskphone me-2"
                      title="Fixed"
                    ></i>
                    <span v-if="cusPhone.phone_number"
                      >{{ cusPhone.phone_number }}
                    </span>
                    <span v-else>{{ cusPhone.phone_raw }} </span>

                    <i
                      v-if="cusPhone.primary == 'Y'"
                      class="fas fa-circle text-success font-size-14 d-none"
                      title="Primary phone"
                    ></i>
                  </span>

                  <span>
                    <a
                      href="javascript:void(0);"
                      title="Edit phone"
                      class="px-2 text-primary float-end"
                      @click="customerInfo.status !== 'deleted' ? callModalPhoneEdit(cusPhone) : null"
                    >
                      <i class="uil uil-pen font-size-18"
                         :class="{ 'disabled': customerInfo.status === 'deleted' }"
                      ></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      title="Remove phone"
                      class="float-end text-danger"
                      @click="customerInfo.status !== 'deleted' ? phoneRemove(cusPhone.phone_id) : null"
                    >
                      <i class="uil uil-trash-alt font-size-18"
                         :class="{ 'disabled': customerInfo.status === 'deleted' }"
                      ></i>
                    </a>
                  </span>
                </p>
              </div>
              <div
                class="mt-3"
                v-if="
                  customerProviderData &&
                    customerProviderData.CustomerType == 1 &&
                    customerTicketingProvider == 'TYMES4'
                "
              >
                <p class="mb-2 text-strong">
                  Company Name :
                  <a
                    href="javascript:void(0);"
                    title="Add Company Name"
                    class="px-2 text-primary float-end"
                    @click="customerInfo.status !== 'deleted' ? callModalCompanyNameEdit(customerInfo.id) : null"
                    v-if="!customerAttributes.company_name"
                  >
                    <i class="uil uil-plus font-size-18"
                       :class="{ 'disabled': customerInfo.status === 'deleted' }"
                    ></i>
                  </a>
                </p>
                <p
                  class="font-size-16 mb-2  justify-content-between"
                  v-if="
                    this.customerAttributes && customerAttributes.company_name
                  "
                >
                  <span class="mw-80">{{
                    customerAttributes.company_name
                  }}</span>
                  <a
                    href="javascript:void(0);"
                    title="Edit Company Name"
                    class="px-2 text-primary float-end"
                    @click="customerInfo.status !== 'deleted' ?  callModalCompanyNameEdit(customerInfo.id,customerAttributes ) : null"
                  >
                    <i class="uil uil-pen font-size-18"
                       :class="{ 'disabled': customerInfo.status === 'deleted' }"
                    ></i>
                  </a>
                </p>
              </div>

              <hr />

              <div v-if="!potentialUser">
                <b-button
                        v-if="menuToArray.includes('button.customer.profile.sentNotification')"
                        class="mb-2 d-block m-auto mwb-11"
                        variant="primary"
                        title="Send Push Notification"
                        @click="callModalSendPushNotification(customerInfo)"
                        :class="{ 'disabled': customerInfo.status === 'deleted' }"
                ><i class="uil-message"></i> Send Notification</b-button
                >
                <b-button
                        v-if="menuToArray.includes('button.customer.profile.changePassword')"
                        class="mb-2 d-block m-auto mwb-11"
                        variant="primary"
                        title="Change Password"
                        @click="callModalChangePassword(customerInfo)"
                        :class="{ 'disabled': customerInfo.status === 'deleted' }"
                ><i class="uil-lock"></i> Change Password</b-button
                >
                <b-button
                        v-if="menuToArray.includes('button.customer.profile.deleteAccount')"
                        class="mb-2 d-block m-auto mwb-11"
                        variant="danger"
                        title="Delete Account"
                        @click="deleteCustomer()"
                        :class="{ 'disabled': customerInfo.status === 'deleted' }"
                ><i class="uil uil-trash-alt"></i>Delete Account</b-button
                >
              </div>
              <div v-else>

                <b-button
                  v-if="menuToArray.includes('button.customer.profile.createCustomerFromPotential')"
                  class="mb-2 d-block m-auto mwb-11"
                  variant="primary"
                  title="Create Customer From Potential"
                  @click="callModalCreateCustomerFromPotential(customerInfo)"
                  :class="{ 'disabled': customerInfo.status === 'deleted' }"
                >
                  <i class="uil-plus"></i> Create Customer From Potential
                </b-button>
                <b-button
                  v-if="menuToArray.includes('button.customer.profile.deletePotentialAccount')"
                  class="mb-2 d-block m-auto mwb-11"
                  variant="danger"
                  title="Delete Potential Account"
                  @click="deletePotentialCustomer()"
                  :class="{ 'disabled': customerInfo.status === 'deleted' }"
                >
                  <i class="uil uil-trash-alt"></i>Delete Potential Account
                </b-button>
              </div>


              <div class="mt-5">
                <p class="mb-1">
                  <strong>Created :</strong>
                  {{
                    customerInfo.hasOwnProperty("created_on")
                      ? customerInfo.created_on
                      : null
                  }}
                </p>
                <p class="mb-1">
                  <strong>Last Login:</strong>
                  {{
                    lastLoginAttempts && lastLoginAttempts.length
                        ? lastLoginAttempts
                        : "Never Logged In"
                  }}
                </p>

              </div>
            </div>
          </div>
          <div
            class="card-body d-flex align-items-center justify-content-center"
            v-else
          >
            <b-spinner large></b-spinner>
          </div>
        </div>
      </div>
      <div v-else class="col-xl-2">
        <div class="card h-100">
          <div class="card-body">
            <div class="text-center">
              <b-dropdown
                class="float-end"
                variant="white"
                right
                menu-class="dropdown-menu-end"
                toggle-class="font-size-16 text-body p-0"
                v-if="!potentialUser"
              >
                <template v-slot:button-content>
                  <i class="uil uil-ellipsis-v"></i>
                </template>
                <a
                  class="dropdown-item"
                  :class="{ 'disabled': customerInfo.status === 'deleted' }"
                  href="javascript:void(0);"
                  @click="callModalUserEdit(customerInfo)"
                  >Edit</a
                >
                <a
                        v-if="menuToArray.includes('button.customer.profile.sentNotification')"
                        class="dropdown-item d-done"
                        :class="{ 'disabled': customerInfo.status === 'deleted' }"
                        href="javascript:void(0);"
                        @click="callModalSendPushNotification(customerInfo)"
                  >Send Notification</a
                >
                <a
                        v-if="menuToArray.includes('button.customer.profile.changePassword')"
                        class="dropdown-item"
                        :class="{ 'disabled': customerInfo.status === 'deleted' }"
                        href="javascript:void(0);"
                        @click="callModalChangePassword(customerInfo)"
                  >Change Password</a
                >
                <a
                  class="dropdown-item"
                  :class="{ 'disabled': customerInfo.status === 'deleted' }"
                  href="javascript:void(0);"
                  @click="callModalResendVerifyEmail()"
                >Resend Verification Email</a>
              </b-dropdown>
              <i
                class="uil uil-angle-right float-start font-size-20 text-body btn p-0"
                @click="toggle"
              ></i>
              <div class="clearfix"></div>
              <div class="d-none">
                <img
                  v-if="avatar"
                  src="@/assets/images/users/avatar-generic.png"
                  alt
                  class="avatar-lg rounded-circle img-thumbnail"
                />
                <img
                  v-else
                  src="@/assets/images/users/avatar-generic.png"
                  alt
                  class="avatar-lg rounded-circle img-thumbnail"
                />
              </div>
              <h5 class="mt-3 mb-1">
                {{ fullName }} <span v-html="showGender()"></span>
              </h5>
              <small class="mt-3 mb-1">{{
                customerInfo.hasOwnProperty("id") ? customerInfo.id : null
              }}</small>
              <small class="d-block mt-3 mb-1" v-if="ssoId && ssoId !== customerInfo.id">
                sso_id:{{ ssoId }}
              </small>

              <div class="mt-4">
                <div
                  class="font-size-18"
                  v-html="format_status(customerStatus())"
                ></div>
              </div>
            </div>
            <hr class="my-2" />

            <div class="table-responsive mt-4 mb-0" v-if="!potentialUser">
              <b-button
                      v-if="menuToArray.includes('button.customer.profile.sentNotification')"
                      class="mb-2 d-block m-auto mwb-9"
                      :class="{ 'disabled': customerInfo.status === 'deleted' }"
                      variant="primary"
                      title="Send Push Notification"
                      @click="callModalSendPushNotification(customerInfo)"
                ><i class="uil-message"></i> Send Notification</b-button
              >
              <b-button
                      v-if="menuToArray.includes('button.customer.profile.changePassword')"
                      class="mb-2 d-block m-auto mwb-9"
                      :class="{ 'disabled': customerInfo.status === 'deleted' }"
                      variant="primary"
                      title="Change Password"
                      @click="callModalChangePassword(customerInfo)"
                ><i class="uil-lock"></i> Change Password</b-button
              >
            </div>
          </div>
        </div>
      </div>

      <div :class="!toggleProfile ? 'col-xl-8' : 'col-xl-10'">
        <div class="card mb-0">
          <b-tabs v-model="activeTab" content-class="p-4" justified class="nav-tabs-custom">
            <b-tab active @shown="getNotificationPreferences" @change="getNotificationPreferences">
              <template v-slot:title>
                <i class="uil uil-user-circle font-size-20"></i>
                <span class="d-none d-sm-block">About</span>
              </template>
              <template v-if="!showLoader">
                <div class="row">
                  <div class="col-sm-12 col-md-3">
                    <div class="mb-2">
                      <p class="mb-1 text-strong">Username :</p>
                      <p class="font-size-16">
                        {{
                          customerInfo.hasOwnProperty("email")
                            ? customerInfo.email
                            : null
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-3">
                    <div class="mb-2">
                      <p class="mb-1 text-strong">Nickname :</p>
                      <p class="font-size-16">
                        {{
                          customerInfo.nickname ? customerInfo.nickname : null
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-2">
                    <div class="mb-2">
                      <p class="mb-1 text-strong">Birthdate :</p>
                      <p class="font-size-16">
                        {{
                          customerInfo.hasOwnProperty("date_of_birth")
                            ? customerInfo.date_of_birth
                            : null
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-2">
                    <div class="mb-2">
                      <p class="mb-1 text-strong">Gender:</p>
                      <p class="font-size-16">{{ this.customerInfo.gender }}</p>
                    </div>
                  </div>
                  <div v-if="tenantAVE || tenantHHC" class="col-sm-12 col-md-2">
                    <div class="mb-2">
                      <p class="mb-1 text-strong">Favorite Club:</p>
                      <p class="font-size-16">{{ this.favClub }}</p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8 col-md-8">
                    <p class="mb-1 text-strong">OptIns:</p>
                    <p
                      v-for="attr in customerAttributesOptIn"
                      v-bind:key="attr.attribute"
                      class="font-size-16 mb-2"
                    >
                      <i
                        v-if="attr.value == '1'"
                        class="mdi mdi-check-circle text-success me-2"
                      ></i>
                      <i
                        v-else
                        class="mdi mdi-alpha-x-circle text-danger me-2"
                      ></i>
                      {{ attr.description }}
                    </p>
                  </div>
                  <div class="col-sm-4 col-md-4">
                      <p class="mb-1 text-strong">Notifications Preferences:</p>
                    <div v-if="!showPreferencesLoader">
                      <span class="text-danger" v-if="customerDevices.length > 1">
                         View push notification preferences for each device on the Devices tab above
                       </span>
                      <div v-else v-for="preference in preferences" :key="preference.type">
                            <span class="font-size-16 mb-2">
                               <i v-if="preference.status == 'Y'"
                                  class="mdi mdi-check-circle text-success me-2"
                               ></i>
                          <i
                                  v-else
                                  class="mdi mdi-alpha-x-circle text-danger me-2"
                          ></i>
                          {{preference.type}}
                            </span>
                      </div>
                      <span class="text-danger" v-if="!customerDevices.length">
                         No Devices
                       </span>
                      <span class="text-danger" v-if="noPushTokenErr">
                          {{noPushTokenErr}}
                       </span>
                    </div>
                    <div v-else class="loader"></div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div
                  class="card-body d-flex align-items-center justify-content-center"
                >
                  <b-spinner large></b-spinner>
                </div>
              </template>
            </b-tab>
            <b-tab v-if="!potentialUser">
              <template v-slot:title>
                <i class="uil uil-mobile-vibrate font-size-20"></i>
                <span class="d-none d-sm-block">Devices</span>
              </template>
              <div class="row">
                <TabCustomerDevices :customer_id="this.$route.params.id" />
              </div>
            </b-tab>
            <b-tab v-if="!potentialUser && menuToArray.includes('games_social')">
              <template v-slot:title>
                <i class="uil-users-alt font-size-20"></i>
                <span class="d-none d-sm-block">Social</span>
              </template>
              <div class="row">
                <TabCustomerSocial
                  :customer_id="this.$route.params.id"
                  @setProviderData="setProviderData"
                />
              </div>
            </b-tab>
            <b-tab v-if="!potentialUser && menuToArray.includes('orders')">
              <template v-slot:title>
                <i class="uil uil-list-ui-alt font-size-20"></i>
                <span class="d-none d-sm-block">Orders</span>
              </template>
              <div class="row">
                <TabCustomerOrders :customer_id="this.$route.params.id" />
              </div>
            </b-tab>
            <b-tab v-if="menuToArray.includes('ticketing')">
              <template v-slot:title>
                <i class="uil uil-ticket font-size-20"></i>
                <span class="d-none d-sm-block">Ticketing</span>
              </template>
              <div class="row">
                <TabCustomerTicketing
                  :customer_id="this.$route.params.id"
                  @setProviderData="setProviderData"
                  @validateUser="validateUser"
                  :customerTicketingValidatedUser="customerTicketingValidatedUser ? 1 : 0"
                  :customerTicketingProvider="customerTicketingProvider"
                  @userVerificationUpdated="customerTicketingValidatedUser = $event"
                />
              </div>
            </b-tab>
            <b-tab v-if="!potentialUser && menuToArray.includes('cashless')">
              <template v-slot:title>
                <i class="uil-credit-card font-size-20"></i>
                <span class="d-none d-sm-block">Cashless</span>
              </template>
              <div>
                <TabCustomerCashless :customer_id="this.$route.params.id" />
              </div>
            </b-tab>
            <b-tab v-if="!potentialUser && menuToArray.includes('games_leaderboard')">
              <template v-slot:title>
                <i class="uil uil-trophy font-size-20"></i>
                <span class="d-none d-sm-block">Fanzone</span>
              </template>
              <div class="row">
                <TabFanExperience :customer_id="this.$route.params.id" />
                <!--Fan Experience goes here-->
              </div>
            </b-tab>
            <b-tab v-if="!potentialUser && menuToArray.includes('games_collectibles')">
              <template v-slot:title>
                <i class="uil uil-layer-group font-size-20"></i>
              <span class="d-none d-sm-block">Collectibles</span>
              </template>
              <div class="row">
                <TabCustomerCollectibles :customer_id="this.$route.params.id" />
              </div>
            </b-tab>
            <b-tab v-if="!potentialUser">
              <template v-slot:title>
                <i class="uil uil-cloud-upload font-size-20"></i>
                <span class="d-none d-sm-block">Cloud Save</span>
              </template>
              <div class="row">
                <TabCustomerCloudSave :customer_id="this.$route.params.id" />
              </div>
            </b-tab>
            <b-tab v-if="!potentialUser">
              <template v-slot:title>
                <i class="mdi mdi-email-outline font-size-20"></i>
                <span class="d-none d-sm-block">Emails</span>
              </template>
              <div class="row">
               <TabCustomerEmails :recipient="primaryEmail" />
              </div>
            </b-tab>
            <!--<b-tab>
                        <template v-slot:title>
                            <i class="uil uil-envelope-alt font-size-20"></i>
                            <span class="d-none d-sm-block">Activity</span>
                        </template>
                        <div>
                            Activity goes here
                        </div>
                    </b-tab>-->
          </b-tabs>
        </div>
      </div>
    </div>
    <div v-else>
      <h3 class="alert alert-danger">
        {{ "There is no such customer record in the Azerion environment" }}
      </h3>
    </div>
    <!-- end row -->

    <!-- MODALS -->
    <modalEditPhone
      :phoneData="modalData"
      @onRefresh="getCustomer()"
    ></modalEditPhone>
    <modalAddPhone
      :customer_id="customer_id"
      @onRefresh="getCustomer()"
    ></modalAddPhone>
    <modalEditAddress
      :addressData="modalData"
      @onRefresh="getCustomer()"
    ></modalEditAddress>
    <modalAddAddress
      :customer_id="customer_id"
      @onRefresh="getCustomer()"
    ></modalAddAddress>
    <modalEditEmail
      :emailData="modalData"
      @onRefresh="getCustomer()"
    ></modalEditEmail>
    <modalEditUser
      :userData="modalData"
      @onRefresh="getCustomer()"
    ></modalEditUser>
    <modalEditAttributes
      :customer_id="customer_id"
      :userData="customerAttributes"
      @onRefresh="getCustomer()"
    ></modalEditAttributes>
    <modalSendPushNotification
      :userData="modalData"
      @onRefresh="getCustomer()"
    ></modalSendPushNotification>
    <modalChangePassword
      :userData="modalData"
      @onRefresh="getCustomer()"
    ></modalChangePassword>
    <modalCreateCustomerFromPotential @onRefresh="handleCreatedFromPotential" >
    </modalCreateCustomerFromPotential>
    <modalChangeUserPicture
        :userData="modalData"
        @onRefresh="getCustomer()" >
    </modalChangeUserPicture>

    <!-- END  MODALS -->
  </Layout>
</template>

<style>
  .loader {
    width: 25px;
    height: 25px;
    border: 3px solid #e0e0e0;         /* light gray ring */
    border-top: 3px solid blue;     /* modern blue accent */
    border-radius: 50%;
    animation: spin 0.75s linear infinite;
    /* optional centering */
    /* display: block; margin: 20px auto; */
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
</style>
